
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";

export default function Header() {
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);
  const [divorceOpenDesktop, setDivorceOpenDesktop] = useState(false);
  const [familyOpenDesktop, setFamilyOpenDesktop] = useState(false);
  const [divorceOpenMobile, setDivorceOpenMobile] = useState(false);
  const [familyOpenMobile, setFamilyOpenMobile] = useState(false);

  const divorceLinks = [
    { title: "חלוקת רכוש ואיזון משאבים", path: "/Property_Distribution_and_Resource_Balancing" },
    { title: "אחריות הורית וזמני שהות", path: "/Parental_Responsibility_and_Visitation_Time" },
    { title: "מזונות ילדים ומזונות אישה", path: "/Child_Support_and_Wife_Support" },
    { title: "ענייני בית הדין הרבני", path: "/Matters_of_the_Rabbinical_Court" },
    { title: "הסכמי גירושין וגישור", path: "/Divorce_and_Mediation_Agreements" },
    { title: "צווים דחופים והגנה", path: "/Urgent_Orders_and_Protection" }
  ];

  const familyLinks = [
    { title: "מרוץ הסמכויות", path: "/The_race_for_authority" },
    { title: "גירושין בינלאומיים", path: "/International_Divorce" },
    { title: "נישואין אזרחיים ופסולי חיתון", path: "/Civil_Marriage_and_Invalid_Marriage" },
    { title: "תביעות נזיקין בין בני זוג", path: "/Torts_Claims_Between_Spouses" },
    { title: "יחסי ממון וצוואות בגירושין", path: "/Prenuptial_Relations_and_Wills_in_Divorce" },
    { title: "אפוטרופסות וניכור הורי", path: "/Guardianship_and_Parental_Alienation" }
  ];

  const regularLinks = [
    { title: "ידועים בציבור ותאים משפחתיים חלופיים", path: "/Common_Law_Partners_and_Surrogate_Family_Units" },
    { title: "ייפוי כוח מתמשך", path: "/Enduring_Power_of_Attorney" },
    { title: "הדרכה ראשונית", path: "/Initial_Legal_Guidance" },
    { title: "מי אני", path: "/About" },
    { title: "צור קשר", path: "/ContactSection2" }
  ];

  const closeMobileMenu = () => {
    setMenuOpen(false);
    setDivorceOpenMobile(false);
    setFamilyOpenMobile(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    closeMobileMenu();
    setDivorceOpenDesktop(false);
    setFamilyOpenDesktop(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        closeMobileMenu();
        setDivorceOpenDesktop(false);
        setFamilyOpenDesktop(false);
      }
    };

    window.addEventListener("keydown", handleEscape);

    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const renderDropdown = (title, links, isOpen, setIsOpen) => (
    <div
      className={`dropdown ${isOpen ? "dropdown-open" : ""}`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        type="button"
        className="drop-title"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((previous) => !previous)}
      >
        {title}
        <span className="dropdown-arrow">⌄</span>
      </button>

      {isOpen && (
        <div className="dropdown-menu">
          {links.map((item) => (
            <Link
              key={item.title}
              to={item.path}
              onClick={() => setIsOpen(false)}
            >
              {item.title}
            </Link>
          ))}
        </div>
      )}
    </div>
  );

  const renderMobileDropdown = (title, links, isOpen, setIsOpen) => (
    <div className={`mobile-dropdown ${isOpen ? "mobile-dropdown-open" : ""}`}>
      <button
        type="button"
        className="mobile-drop-title"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((previous) => !previous)}
      >
        <span>{title}</span>
        <span className="mobile-dropdown-arrow">{isOpen ? "−" : "+"}</span>
      </button>

      {isOpen && (
        <div className="mobile-submenu">
          {links.map((item) => (
            <Link
              key={item.title}
              to={item.path}
              onClick={closeMobileMenu}
            >
              {item.title}
            </Link>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <>
      <header className={`header ${menuOpen ? "menu-open" : ""}`}>
        <Link
          to="/"
          className="logo"
          onClick={closeMobileMenu}
        >
          <img
            src="/logo.png"
            alt="רז יוסף – משרד עורכי דין"
          />
        </Link>

        <nav className="nav desktop-nav" aria-label="תפריט ראשי">
          <Link to="/">בית</Link>

          {renderDropdown(
            "גירושין",
            divorceLinks,
            divorceOpenDesktop,
            setDivorceOpenDesktop
          )}

          {renderDropdown(
            "דיני משפחה וירושה",
            familyLinks,
            familyOpenDesktop,
            setFamilyOpenDesktop
          )}

          {regularLinks.map((item) => (
            <Link key={item.title} to={item.path}>
              {item.title}
            </Link>
          ))}
        </nav>

        <div className="left-section">
          <Link
            to="/ContactSection2"
            className="cta-btn"
            onClick={closeMobileMenu}
          >
            לתיאום פגישת ייעוץ
          </Link>

          <a
            href="tel:0507575775"
            className="contact"
            aria-label="התקשרו למשרד עורכי דין רז יוסף"
          >
            <span className="contact-icon">☎</span>

            <span className="contact-text">
              <span className="contact-title">לשיחת ייעוץ</span>
              <span className="contact-number">050-757-5775</span>
            </span>
          </a>

          <button
            type="button"
            className="hamburger"
            onClick={() => setMenuOpen((previous) => !previous)}
            aria-label={menuOpen ? "סגירת תפריט" : "פתיחת תפריט"}
            aria-expanded={menuOpen}
          >
            {menuOpen ? "✕" : "☰"}
          </button>
        </div>
      </header>

      <div
        className={`overlay ${menuOpen ? "show" : ""}`}
        onClick={closeMobileMenu}
        aria-hidden="true"
      />

      <nav
        className={`mobile-menu ${menuOpen ? "open" : ""}`}
        aria-label="תפריט למכשירים ניידים"
        aria-hidden={!menuOpen}
      >
        <button
          type="button"
          className="close-btn"
          onClick={closeMobileMenu}
          aria-label="סגירת תפריט"
        >
          ✕
        </button>

        <Link to="/" onClick={closeMobileMenu}>
          בית
        </Link>

        {renderMobileDropdown(
          "גירושין",
          divorceLinks,
          divorceOpenMobile,
          setDivorceOpenMobile
        )}

        {renderMobileDropdown(
          "דיני משפחה וירושה",
          familyLinks,
          familyOpenMobile,
          setFamilyOpenMobile
        )}

        {regularLinks.map((item) => (
          <Link
            key={item.title}
            to={item.path}
            onClick={closeMobileMenu}
          >
            {item.title}
          </Link>
        ))}

        <Link
          to="/ContactSection2"
          className="mobile-cta"
          onClick={closeMobileMenu}
        >
          לתיאום פגישת ייעוץ
        </Link>
      </nav>
    </>
  );
}
